export default "__VITE_ASSET__C8ishNCM__"